(function ($) {

	document.querySelectorAll('.preview-card').forEach(card => {
		if (card) {
			card.addEventListener('click', handlePreviewClick);
		}
	});

	function handlePreviewClick(e) {
		e.preventDefault();
		let text = $(this).closest('.card').find("textarea[name*='card_text']").val(),
			heading = $(this).closest('.card').find(".product-name").text();

		$(this).closest('.card').find('.preview-side .preview-text').html(text);
		$(this).closest('.card').find('.preview-side .preview-prod-heading').html(heading);

		let targeted = $(this).closest('.card').find('.preview-side');
		if ($(window).width() < 768) {
			$('html, body').animate({
				scrollTop: $(targeted).offset().top
			}, 500);
		}
	}

	$(document).on('click', '.remove', function () {
		let prod_id = $(this).data('product_id');
	
		$('.card').each(function () {
			if ($(this).attr('id').startsWith('card-' + prod_id)) {
				$(this).remove();
			}
		});
	});

	// We want to show the update cart button, but we need to force it to show up.
	// The change function with cartAnswer wants to show the update cart button by default, but we hide it in that function.
	if (document.querySelector('.woocommerce')) {
		document.querySelector('.woocommerce').addEventListener('change', function(event) {
			if (event.target && event.target.matches('input.qty')) {
				document.querySelector("[name='update_cart']").style.display = 'block';
			}
		});
	}

	document.querySelectorAll(".woocommerce input[name*='cartAnswer']").forEach(input => {
		input.addEventListener('change', function() {
			if (Array.from(document.querySelectorAll(".woocommerce input[name*='cartAnswer']")).some(input => input.checked)) {
				let cartval = this.value;
				document.querySelector('.woocommerce-cart button[name="update_cart"]').style.display = 'none';
				
				document.querySelectorAll('.card').forEach(card => {
					const cardHTML = card.innerHTML;
					if (cartval.includes("no")) {
						if (card.id.includes(cartval.substr(3))) {
							while (card.firstChild) {
								card.removeChild(card.firstChild); // Remove DOM elements
							}
							card.classList.add('empty');
	
							if (document.querySelectorAll('.card .input-form').length === 0) {
								document.querySelector('.lahjakortit .giftcards-heading').classList.add('hide');
								document.querySelector('.lahjakortit .preview-heading').classList.add('hide');
							}
	
							setdet = cardHTML;
						}
					} else if (cartval.includes("ye")) {
						if (card.id.includes(cartval.substr(3))) {
							card.innerHTML = setdet; // Reattach DOM elements
	
							// Reattach event handlers
							document.querySelectorAll('.preview-card').forEach(previewCard => {
								previewCard.addEventListener('click', handlePreviewClick);
							});
	
							document.querySelectorAll('.input-time').forEach(inputTime => {
								inputTime.addEventListener('click', handleInputTime);
							});
	
							card.classList.remove('empty');
							document.querySelector('.lahjakortit .giftcards-heading').classList.remove('hide');
							document.querySelector('.lahjakortit .preview-heading').classList.remove('hide');
						}
					}
				});
			}
		});
	});

	document.querySelectorAll('.input-time').forEach(input => {
		input.addEventListener('click', handleInputTime);
	});

	function handleInputTime() {
		$(this).find("input").prop('checked', true);

		if ($(this).hasClass('now')) {
			$(this).closest('.card').find('.schedule').slideUp(250);
		}

		if ($(this).hasClass('later')) {
			$(this).closest('.card').find('.schedule').slideDown(250);
		}
	}

}(jQuery));
